module.exports = __webpack_public_path__ + "img/2w1.05adea26.jpg";